module.exports = __webpack_public_path__ + "static/NDIA_Logo-web-21d5658692ffa2291b84d1ffdcbebaa3.png";